<template>
  <div class="couserwareTecDeatil">
    <div class="header">
      <el-row :gutter="1" type="flex">
        <el-col :span="10"
          ><span class="title">统计日期:</span>
          <datePicker
            :value="{ startDate: searchForm.startDate, endDate: searchForm.endDate }"
            @dateValue="dateValue"
          />
        </el-col>
        <el-col :span="7">
          <span class="title">省市区:</span
          ><el-cascader
            :options="options"
            v-model="cityValue"
            :props="{ multiple: true }"
            collapse-tags
            clearable
            @change="cityChange"
            @visible-change="cityVisible"
            @remove-tag="removeTag"
          ></el-cascader>
        </el-col>
        <el-col :span="7"
          ><span class="title">学校:</span
          ><filterSelect
            id="cou1"
            ref="filterSelect1"
            :optionsList="schoolList"
            :defaultChecked="defaultSchool"
            @checked="schoolChecked"
        /></el-col>
      </el-row>
      <el-row :gutter="1" type="flex">
        <el-col :span="10">
          <span class="title">教师名称:</span
          ><filterSelect
            id="cou2"
            ref="filterSelect2"
            placeholder="请输入教师名称"
            :optionsList="tecList"
            @checked="tecChecked"
          />
          <el-button style="margin-left: 5px" size="small" @click="reset">重置</el-button>
          <el-button type="primary" size="small" @click="search">查询</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <div class="hint">
        <div class="left">
          教师明细 (课件)
          <el-popover
            placement="bottom-start"
            width="400"
            trigger="hover"
            :visible-arrow="false"
            popper-class="popper-hint"
          >
            <div v-html="JSMXKJFX"></div>
            <i class="el-icon-info" slot="reference"></i>
          </el-popover>
        </div>
        <div class="right">
          <el-button type="primary" size="small" @click="downExcel" :loading="downLoading">导出数据</el-button>
        </div>
      </div>
      <div class="table">
        <el-table
          v-if="!emptyIsShow"
          :data="tableData"
          :key="keytable"
          ref="table"
          border
          size="small"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          stripe
          height="100%"
          :default-sort="{ prop: 'upLoadCourseWareNum', order: 'descending' }"
          @sort-change="sortChange"
          v-loading="loading"
        >
          <el-table-column sortable="custom" fixed type="index" label="排名" width="80">
            <template slot-scope="scope">
              <span>{{ (searchForm.pageNum - 1) * searchForm.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed prop="teacherName" label="教师名称" width="auto"> </el-table-column>
          <el-table-column fixed prop="schoolName" label="学校名称" width="auto"> </el-table-column>
          <el-table-column sortable="custom" prop="upLoadCourseWareNum" label="上传课件数" width="auto">
          </el-table-column>
          <el-table-column sortable="custom" prop="prepareLessonUseCourseWareNum" label="备课使用课件数" width="auto">
          </el-table-column>
          <el-table-column sortable="custom" prop="inClassUseCourseWareNum" label="授课使用课件数" width="auto">
          </el-table-column>
        </el-table>
        <el-empty v-if="emptyIsShow" description="暂无数据" :image-size="80" style="margin-top: 100px"></el-empty>
      </div>
      <div class="pagSize" v-if="!emptyIsShow">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="searchForm.pageSize"
          :current-page.sync="searchForm.pageNum"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import filterSelect from '../../components/FilterSelect/index.vue'
import datePicker from '../../components/datePicker/index.vue'
import { JSMXKJFX } from '@/utils/explainText.js'
import { lastWeek } from '@/utils/date.js'
import fileSave from '@/utils/fileSave.js'

import { courseWareDetail } from '@/api/modules/excelApi.js'
import { generateTableParms, getToken, excelName } from '@/utils/index.js'
import { resize } from '@/mixins/resize.js'
export default {
  name: 'CouserwareTecDeatil',
  mixins: [resize],
  components: {
    filterSelect,
    datePicker
  },
  data() {
    return {
      schoolList: JSON.parse(sessionStorage.getItem('schoolList')),
      tecList: [],
      JSMXKJFX: JSMXKJFX,
      loading: false,
      emptyIsShow: false,
      tableData: [],
      options: JSON.parse(sessionStorage.getItem('cityList')),
      searchForm: {
        startDate: lastWeek().startOf,
        endDate: lastWeek().endOf,
        loginUserId: JSON.parse(sessionStorage.getItem('userInfo')).Key,
        schoolIds: [],
        pageNum: 1,
        pageSize: 12,
        teacherIds: [],
        provinceIds: [],
        cityIds: [],
        localeIds: [],
        ascOrDes: false,
        sortCode: 'upLoadCourseWareNum'
      },
      total: 0,
      cityValue: [],
      address: {
        provinceIds: [],
        cityIds: [],
        localeIds: [],
        loginUserId: JSON.parse(sessionStorage.getItem('userInfo')).Key
      },
      keytable: 0,
      defaultSchool: [],
      downLoading: false
    }
  },
  created() {
    this.$store.commit('SET_ISBACK', true)
    let info = this.$route.query
    this.searchForm.schoolIds.push(info.schoolId)
    this.searchForm.endDate = info.endDate
    this.searchForm.startDate = info.startDate
    this.defaultSchool.push(this.schoolList[this.schoolList.findIndex((el) => el.value == info.schoolId)])
    this.getList()
    // this.getSchools();
  },
  mounted() {
    this.getTecs()
  },
  destroyed() {
    this.$store.commit('SET_ISBACK', false)
    this.tecList = []
  },
  methods: {
    dateValue(v) {
      this.searchForm.startDate = v.startDate
      this.searchForm.endDate = v.endDate
      // console.log(v);
    },
    schoolChecked(v) {
      // console.log(v, "schoolChecked");
      this.searchForm.schoolIds = []
      // this.searchForm.teacherIds = [];
      v.forEach((el) => {
        this.searchForm.schoolIds.push(el.value)
      })
      this.getTecs()
    },
    tecChecked(v) {
      this.searchForm.teacherIds = []
      v.forEach((el) => {
        this.searchForm.teacherIds.push(el.value)
      })
    },
    // 重置
    reset() {
      this.$refs.filterSelect1.checkedValue = this.defaultSchool[0].label
      this.$refs.filterSelect2.checkedValue = ''
      this.searchForm = this.$options.data().searchForm
      this.searchForm.startDate = this.$route.query.startDate
      this.searchForm.endDate = this.$route.query.endDate
      this.searchForm.schoolIds.push(this.$route.query.schoolId)
      this.address = this.$options.data().address
      this.keytable += 1
      this.schoolList = JSON.parse(sessionStorage.getItem('schoolList'))
      this.cityValue = []
      this.getList()
      this.getTecs()
    },
    //查询
    search() {
      this.searchForm.pageNum = 1
      this.getList()
    },
    // 排序
    sortChange({ column, prop, order }) {
      this.searchForm.sortCode = prop
      if (order !== null) {
        order == 'descending' ? (this.searchForm.ascOrDes = false) : (this.searchForm.ascOrDes = true)
        this.getList()
      }
    },
    // 省市区选择器
    cityChange(v) {
      this.address = this.$options.data().address
      if (v.length < 1) {
        this.searchForm.provinceIds = this.searchForm.cityIds = this.searchForm.localeIds = []
        this.getSchools()
        this.getTecs()
        return
      }
      v.forEach((el) => {
        this.address.provinceIds.push(el[0])
        this.address.cityIds.push(el[1])
        this.address.localeIds.push(el[2])
        this.searchForm.provinceIds = this.address.provinceIds
        this.searchForm.cityIds = this.address.cityIds
        this.searchForm.localeIds = this.address.localeIds
      })
      // this.searchForm.schoolIds = this.searchForm.teacherIds = []
    },
    removeTag(v) {
      // console.log(v);
      let i = this.address.provinceIds.findIndex((el) => el == v[0])
      this.address.provinceIds.splice(i, 1)
      this.address.cityIds.splice(i, 1)
      this.address.localeIds.splice(i, 1)
      if (this.address.provinceIds.length > 0) {
        // this.searchForm.schoolIds = this.searchForm.teacherIds = []
        this.getSchools()
        this.getTecs()
      }
    },
    // 省市区选择器收起时
    cityVisible(v) {
      // console.log(v);
      if (!v && this.address.provinceIds.length > 0) {
        // console.log("请求");
        this.getSchools()
        this.getTecs()
      }
    },
    getSchools() {
      this.$refs.filterSelect1.checkedValue = ''
      this.searchForm.schoolIds = []
      this.$API.basicsApi.getSchoolList(this.address).then((res) => {
        // console.log(res);
        // this.$refs.filterSelect1.uncertainCheckedList = [];
        this.schoolList = res.result.map((el) => {
          el.label = el.schoolName
          el.value = el.schoolId
          delete el.schoolId
          delete el.schoolName
          delete el.total
          return el
        })
      })
    },
    getTecs() {
      let obj = {
        loginUserId: this.searchForm.loginUserId,
        schoolIds: this.searchForm.schoolIds,
        ...this.address
      }
      this.$refs.filterSelect2.checkedValue = ''
      this.searchForm.teacherIds = []
      this.$API.basicsApi.getTecList(obj).then((res) => {
        // console.log(res, "tec");
        this.tecList = res.result.map((el) => {
          el.label = el.teaName
          el.value = el.teaId
          delete el.teaName
          delete el.teaId
          return el
        })
        // console.log(this.tecList);
      })
    },
    getList() {
      this.loading = true
      this.$API.couserwareAnalysisApi
        .couserwareDetail(this.searchForm)
        .then((res) => {
          // console.log(res);
          this.tableData = res.result
          if (this.tableData.length > 0) {
            this.emptyIsShow = false
            this.total = this.tableData[0].total
          } else {
            this.total = 0
            this.emptyIsShow = true
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.searchForm.pageNum = val
      this.getList()
    },
    // 导出表格
    downExcel() {
      this.downLoading = true

      let obj = {
        fileName: '',
        ...this.searchForm,
        ...getToken()
      }
      delete obj.pageSize
      delete obj.pageNum
      obj.fileName = excelName('教师课件使用分析', obj.startDate, obj.endDate)
      fileSave(courseWareDetail + generateTableParms(obj), obj.fileName + '.xlsx').then(() => {
        this.downLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.couserwareTecDeatil {
  @include myMain();
  .header {
    @include myHeader();
  }
  .content {
    @include myContent();
    .hint {
      @include myContent-hint();
    }
    .table {
      @include myTable();
    }
    .pagSize {
      @include myPagSize();
    }
  }
}
</style>
